/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Página sem título',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Crie uma página nova para inserir como link',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Criar página do Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Abrir no Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'A página foi criada',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Página criada',
  'editorExtensionLinkCreate.confluencePage.title': 'Criar nova página',
  'editorExtensionLinkCreate.genericError.description': 'Atualize a página e tente outra vez.',
  'editorExtensionLinkCreate.genericError.title': 'Algo deu errado',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Crie um item em linha e insira o item como link',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    'Crie um ticket em linha e insira como link',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Criar item no Jira',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Criar ticket no Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Abrir no Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'O item foi criado',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4': 'O ticket foi criado',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Item criado',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': 'Ticket criado',
  'editorExtensionLinkCreate.jiraIssue.title': 'Criar item novo',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': 'Criar ticket novo',
  'editorExtensionLinkCreate.keyword.create': 'criar',
  'editorExtensionLinkCreate.keyword.issue': 'ticket',
  'editorExtensionLinkCreate.keyword.new': 'novo',
  'editorExtensionLinkCreate.keyword.page': 'página',
  'editorExtensionLinkCreate.keyword.publish': 'publicar',
  'editorExtensionLinkCreate.keyword.raise': 'criar',
  'editorExtensionLinkCreate.keyword.space': 'espaço',
  'editorExtensionLinkCreate.keyword.ticket': 'ticket',
};
